var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-funnel-graph',{attrs:{"width":_vm.width,"height":_vm.height,"labels":_vm.labels,"values":_vm.values,"colors":_vm.colors,"sub-labels":_vm.subLabels,"direction":_vm.direction,"gradient-direction":_vm.gradientDirection,"animated":true,"display-percentage":true,"sub-label-value":_vm.subLabelValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }